import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/obbVenditaAnnuali';

const routes = helper.generateRoutes('obbVenditaAnnuali', selectors);
routes.list.list.breadcrumb = `Obbiettivi di vendita annuali`;
const list = _.values(routes.list).map(route => ({
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'obbVenditaAnnuali' */ `modules/obbVenditaAnnuali/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('obbVenditaAnnuali', routes.patterns);
routeRegister.addLinks('obbVenditaAnnuali', links);

export default list;